









































import {
  computed,
  defineComponent,
  reactive,
  watch,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useFormat } from '@ideavivat/vivat-2';
import { parse } from 'graphql';

import updateHoliday from '@/gql/systemCalendar/updateHoliday.gql';
import deleteHoliday from '@/gql/systemCalendar/deleteHoliday.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const NOW = useFormat.date().computerShortDate();

const CommonFormWithSystemCalendarEditor = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  props: {
    holiday: Object,
  },
  setup(props, { emit }) {
    const form = reactive({
      date: {
        from: NOW,
        to: NOW,
      },
      description: '',
    });

    const computedDatesArray = computed(() => {
      const fromAsDayJS = useFormat.date(form.date.from).dayjs;
      const result = [useFormat.date(form.date.from).computerShortDate()];
      const diff = (useFormat.date(form.date.to).dayjs).diff(fromAsDayJS, 'day');
      for (let i = 1; i <= diff; i += 1) {
        result.push(useFormat.date(fromAsDayJS.add(i, 'day')).computerShortDate());
      }
      return result;
    });
    const computedCreateHolidayMutationGQL = computed(() => {
      let result = 'mutation createHolidayMutation {';
      computedDatesArray.value.forEach((date: string, index: number) => {
        result = `${result} createHoliday_${index}: createHoliday(input: { date: "${date}", description: "${form.description}" }) { id date description }`;
      });
      return `${result}}`;
    });
    const createHolidayMutation = useMutation(() => parse(computedCreateHolidayMutationGQL.value), () => ({
      refetchQueries: ['getHolidays'],
    }));

    const updateHolidayMutation = useMutation(updateHoliday, () => ({
      variables: {
        input: {
          id: props.holiday?.id,
          description: form.description,
          date: form.date.from,
        },
      },
      refetchQueries: ['getHolidays'],
      // update: (cache: any) => {
      //   cache.evict({ id: 'ROOT_QUERY' });
      // },
    }));

    const computedMutation = computed(() => {
      if (props.holiday?.id > 0) return updateHolidayMutation;
      return createHolidayMutation;
    });

    watch(() => props.holiday, (newVal, oldVal) => {
      if (newVal?.id > -1 && newVal !== oldVal) {
        form.description = newVal?.title;
      }
    });

    function clear() {
      emit('cancel');
      form.description = '';
    }

    const deleteHolidayMutation = useMutation(deleteHoliday, () => ({
      variables: {
        id: props.holiday?.id,
      },
      refetchQueries: ['getHolidays'],
      // update: (cache: any) => {
      //   cache.evict({ id: 'ROOT_QUERY' });
      // },
    }));
    function pendingDeleteHoliday() {
      deleteHolidayMutation.mutate();
    }
    deleteHolidayMutation.onDone(() => {
      clear();
    });

    return {
      form,
      clear,
      computedDatesArray,
      computedCreateHolidayMutationGQL,

      computedMutation,

      pendingDeleteHoliday,
    };
  },
});

export default CommonFormWithSystemCalendarEditor;
